import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { Module } from 'vuex'
import RootState from '@/store/RootState'
import StockState from './StockState'

const stockModule: Module<StockState, RootState> = {
  namespaced: true,
  state: {
    cached: {},
    tasks: {
      list: [],
      total: 0
    },
    coldTasks: {
      list: [],
      total: 0
    },
    stockDetails: {},
  },
  getters,
  mutations,
  actions
}

export default stockModule;
